/**
 * Plugins pour instancier le bus d'events entre les composants
 */
import Vue from 'vue';

const coEventBus = new Vue();

Plugin.install = function (inoVue, options) { // eslint-disable-line
  inoVue.prototype.$bus = coEventBus; // eslint-disable-line
};

Vue.use(coEventBus);

export default Plugin;
